var map = {
	"./navigation.de-CH.json": 1070,
	"./navigation.de-DE.json": 1071,
	"./navigation.en-CA.json": 1072,
	"./navigation.en-GB.json": 1073,
	"./navigation.en-IN.json": 1074,
	"./navigation.en-ME.json": 1075,
	"./navigation.en-US.json": 1076,
	"./navigation.es-EM.json": 1077,
	"./navigation.es-ES.json": 1078,
	"./navigation.fr-BE.json": 1079,
	"./navigation.fr-CA.json": 1080,
	"./navigation.fr-CH.json": 1081,
	"./navigation.nl-BE.json": 1082,
	"./navigation.nl-NL.json": 1083,
	"./navigation.pl-PL.json": 1084,
	"./navigation.pt-BR.json": 1085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1069;